import React, { useState, useCallback } from "react";

const ReminderStatusToggle = ({
  initialStatus,
  toggleUrl,
  csrfToken,
  disabled = false
}) => {
  const [status, setStatus] = useState(initialStatus);
  const [isLoading, setIsLoading] = useState(false);

  const isActive = status === 'active';

  const handleToggle = useCallback(async () => {
    if (disabled || isLoading) return;

    setIsLoading(true);
    const newStatus = isActive ? 'inactive' : 'active';

    try {
      const response = await fetch(toggleUrl, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken,
        },
        body: JSON.stringify({ status: newStatus }),
      });

      const data = await response.json();

      if (data.success) {
        setStatus(data.status);
      } else {
        console.error('Failed to toggle status:', data.error);
      }
    } catch (error) {
      console.error('Error toggling status:', error);
    } finally {
      setIsLoading(false);
    }
  }, [toggleUrl, csrfToken, isActive, disabled, isLoading]);

  return (
    <div className="flex items-center gap-3">
      <button
        type="button"
        onClick={handleToggle}
        disabled={isLoading || disabled}
        className={`
          relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent
          transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2
          ${isActive ? 'bg-green-500' : 'bg-gray-300'}
          ${(isLoading || disabled) ? 'opacity-50 cursor-not-allowed' : ''}
        `}
        role="switch"
        aria-checked={isActive}
      >
        <span className="sr-only">Toggle reminder status</span>
        <span
          className={`
            pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0
            transition duration-200 ease-in-out
            ${isActive ? 'translate-x-5' : 'translate-x-0'}
          `}
        />
      </button>
      <span className={`text-sm font-medium ${isActive ? 'text-green-700' : 'text-gray-500'}`}>
        {isLoading ? (
          <span className="flex items-center gap-1.5">
            <svg className="animate-spin h-3 w-3" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Saving...
          </span>
        ) : (
          isActive ? 'Active' : 'Inactive'
        )}
      </span>
    </div>
  );
};

export default ReminderStatusToggle;
